module.exports = __webpack_public_path__ + "static/media/169-pitcairn-islands.69d7d03c.svg";